import React, { Component } from "react"
import {FormTable} from './FormTable'
import { auth, db } from '../../../service';


export class Form extends Component {

    constructor(props) {
        super(props)
        this.state = {
            datas: [],
            user: null,
            query: '',
            user_count: null
        }
        this.handleSearch=this.handleSearch.bind(this)
        this.handleCount=this.handleCount.bind(this)

    }

    componentDidMount(){
        this.handleSearch()
        this.handleCount()
    }
    handleSearch(){
        const {query} = this.state
        const datas = []
        db.collection('users').where("name", ">=", query).limit(50).get().then((querySnapshot) => {
            querySnapshot.forEach(function(doc) {
                datas.push({"id": doc.id, "name": doc.data()['name'], "gender": doc.data()['gender'], "email": doc.data()['email'], "fbID": doc.data()['fbID'], "photoURL": doc.data()['photoURL'], "uid": doc.data()['uid'], "userAgreementAcceptedTime": doc.data()['userAgreementAcceptedTime']})
            });

            this.setState({datas})

          }).catch((error) => {
              alert(error)
          })
    }
    handleCount(){
        db.collection('users').get().then(snap => {
            this.setState({user_count: snap.size})
         });

    }

    render() {
        const {datas} = this.state
        return (
            <div>
                <div className="row">
                    <div class="col-12 col-lg-6 col-xl-3">
                        <div class="card border-info border-left-sm">
                            <div class="card-body">
                            <div class="media align-items-center">
                            <div class="media-body text-left">
                                <h4 class="text-info mb-0">{this.state.user_count}</h4>
                                <span>Хэрэглэгчид</span>
                            </div>
                            <div class="align-self-center w-circle-icon rounded-circle gradient-scooter">
                                <i class="icon-user text-white"></i></div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="main-content">
                    <div className="">
                        <div id="example_wrapper" className=" shadow-lg p-3 mb-5 bg-white rounded">

                        <input
                            type="text"
                            className="form-control col-md-4  mb-1 float-left"
                            id="query"
                            placeholder="Хайх"
                            onChange={(e) => this.setState({query: e.target.value})}
                            value={this.state.query}
                        />
                        <button type="button" class="btn btn-outline-info" onClick={this.handleSearch}>
                            Хайх
                        </button>
                        <div className="table-responsive">
                            <table className="table example" id="example">
                                <thead>
                                    <tr>
                                        <th style={{width:"2%"}} scope="col">№</th>
                                        <th style={{width:"5%"}} scope="col">Зураг</th >
                                        <th style={{width:"10%"}} scope="col">Нэр</th>
                                        <th style={{width:"10%"}} scope="col">Майл</th >
                                        <th style={{width:"10%"}} scope="col">Фэйсбүүк</th >
                                        <th style={{width:"10%"}} scope="col">Дугаар</th >
                                        <th style={{width:"10%"}} scope="col">login date</th >
                                        <th style={{width:"2%"}} scope="col">Засах</th >
                                        <th style={{width:"2%"}} scope="col">Устгах</th >
                                    </tr>
                                </thead>
                                <tbody>
                                    {datas.map((huulga, idx) =>
                                        <FormTable key = {idx} idx={idx+1} values={huulga}></FormTable>
                                    )}
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}
